import BaseLayout from 'layouts';
import { IBusinessProfileLayout } from '../../interfaces/components/layout.interface';

const BusinessProfileLayout = ({ children }: IBusinessProfileLayout) => {
  return (
    <BaseLayout>
      <article className="mx-auto mb-32 w-full max-w-container self-center px-4 md:my-4 md:px-5">
        {children}
      </article>
    </BaseLayout>
  );
};

export default BusinessProfileLayout;
